import { CSSProperties } from 'react'
import './LoadingSpinner.scss'

export function LoadingSpinner(props: { size?: number; color?: string }) {
  const style: CSSProperties = {
    width: props.size,
    height: props.size,
    borderColor: props.color ? `${props.color} ${props.color} transparent ${props.color}` : undefined,
  }

  return <i className={`loading-spinner`} style={style} />
}
